
export const SNEAKERS_BARU_PHOTO_MESSAGE = [
  'Make sure you have a good lighting to take clear picture. Take different angles of the product. Also, include any picture of the defects / issues if any.',
  'Upload 5 photos for Brand New items. Upload 7 photos for Pre Owned / Used items.',
];

export const SNEAKERS_BEKAS_PHOTO_MESSAGE = [
  'Make sure you have a good lighting to take clear picture. Take different angles of the product. Also, include any picture of the defects / issues if any.',
  'Upload 5 photos for Brand New items. Upload 7 photos for Pre Owned / Used items.',
];

export const STREETWEAR_PHOTO_MESSAGE = [
  'Make sure you have a good lighting to take clear picture. Take different angles of the product. Also, include any picture of the defects / issues if any.',
];

export const LUXURY_PHOTO_MESSAGE = [
  'Make sure you have a good lighting to take clear picture. Take different angles of the product. Also, include any picture of the defects / issues if any.',
  'Do take pictures of all the inclusions (or accessories) that come along with the product.',
];

export const TICKETS_PHOTO_MESSAGE = [
  'Make sure you have a good lighting to take clear picture. Take different angles of the product.',
];

export const CATEGORY_ARRAY = [
  {
    text: 'Sneakers',
    value: 'sneakers',
    roles: 'seller',
  },
  {
    text: 'Apparel',
    value: 'apparels',
    roles: 'seller_apparel',
  },
  {
    text: 'Luxury',
    value: 'handbags',
    roles: 'seller_handbag',
  },
  {
    text: 'Electronics & Collectibles',
    value: 'lifestyles',
    roles: 'seller_lifestyle',
  },
];

export const productConditionSneakers = [
  { value: 'BARU', label: 'BRAND NEW' },
  { value: 'BEKAS', label: 'PRE OWNED' },
];

export const productConditionApparels = [
  { value: 'BARU', label: 'BRAND NEW' },
  { value: 'BEKAS', label: 'PRE OWNED' },
];

export const productConditionHandbags = [
  { value: 'BARU', label: 'BRAND NEW' },
  { value: 'PRISTINE', label: 'PRISTINE' },
  { value: 'GOOD', label: 'GOOD' },
  { value: 'WELL_USED', label: 'WELL USED' },
  { value: 'LIKE_NEW', label: 'LIKE NEW' },
  { value: 'VINTAGE', label: 'VINTAGE' },
];

export const boxCondition = [
  { value: 'SEMPURNA', label: 'PERFECT' },
  { value: 'CACAT', label: 'DEFECT' },
  { value: 'NO_BOX', label: 'MISSING BOX' },
];